import { Component } from '@angular/core';
import { DevelopChallengeComponent } from '../develop-challenge.component';
import { CnAiService } from '../../challenges_service/cn-ai.service';

@Component({
  selector: 'app-develop-challenge-new-thinking',
  templateUrl: './develop-challenge-new-thinking.component.html',
  styleUrls: ['./develop-challenge-new-thinking.component.scss']
})
export class DevelopChallengeNewThinkingComponent {

  constructor(public developChallengeComponent: DevelopChallengeComponent, private aiService: CnAiService) {}

  openAiSidebar() {
    const context = this.developChallengeComponent?.thinking_content?.[1] || [];
    this.aiService.openSidebar(
      'develop', 'new-thinking', context,
      'Generate 5 new thinking approaches {persona} to overcome identified issues. Current context: {context}',
      'thinking_content', this.developChallengeComponent
    );
  }
}
